import React from "react";

function AHPIcon({ children }) {
  return (
    <div>
      <img
        src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2019/12/ahp_logo_pos_800x200px.jpg"
        alt="Logo Aldeias Históricas de Portugal"
        width="110"
        height="auto"
      />
      {children}
    </div>
  );
}

export default AHPIcon;
